/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_ReplacementInputs */

const en_update_replacement = /** @type {(inputs: Update_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Replacement`)
};

const fr_update_replacement = /** @type {(inputs: Update_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour le remplacement`)
};

const de_update_replacement = /** @type {(inputs: Update_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisierungsersatz`)
};

const it_update_replacement = /** @type {(inputs: Update_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento sostituzione`)
};

const ru_update_replacement = /** @type {(inputs: Update_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить замену`)
};

const es_update_replacement = /** @type {(inputs: Update_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazo de actualización`)
};

const zh_cn2_update_replacement = /** @type {(inputs: Update_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新替换`)
};

const ja_update_replacement = /** @type {(inputs: Update_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップデートの置き換え`)
};

const hi_update_replacement = /** @type {(inputs: Update_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिस्थापन अपडेट करें`)
};

const pt_pt2_update_replacement = /** @type {(inputs: Update_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização Substituição`)
};

/**
* | output |
* | --- |
* | "Update Replacement" |
*
* @param {Update_ReplacementInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_replacement = /** @type {((inputs?: Update_ReplacementInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_ReplacementInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_update_replacement(inputs)
	if (locale === "de") return de_update_replacement(inputs)
	if (locale === "it") return it_update_replacement(inputs)
	if (locale === "ru") return ru_update_replacement(inputs)
	if (locale === "es") return es_update_replacement(inputs)
	if (locale === "zh-CN") return zh_cn2_update_replacement(inputs)
	if (locale === "ja") return ja_update_replacement(inputs)
	if (locale === "hi") return hi_update_replacement(inputs)
	if (locale === "pt-PT") return pt_pt2_update_replacement(inputs)
	return en_update_replacement(inputs)
});